<div class="container">
  <div class="logo-container mb-15">
    <img src="../../assets/datastorioLogo.png" width="180">
  </div>
  <mat-card class="card p-15">
    <mat-card-title>
      <div class="card-header">
        <h2>Enter Your Tenant ID</h2>
      </div>
    </mat-card-title>
    <form (submit)="onSubmit($event)">
      <mat-card-content class="p-15">
        <mat-form-field class="inpt">
          <mat-label>Tenant Id</mat-label>
          <input matInput [value]="tenantId" (input)="updateTenantId($event)">
        </mat-form-field>
      </mat-card-content>
      <div class="btn-container">
        <button type="submit" class="primary-btn mr-10 mb-10" mat-flat-button color="primary">Login
        </button>
      </div>
    </form>
  </mat-card>

</div>
